module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-calendar-067de32705105b3c3ef445270809d00b.svg";